// import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLastPayment } from 'hooks';
import { Result, Space, Typography, Button } from 'antd';
import imageSource from 'assets/images/Positive.svg';
import { localStorageService } from 'utils/LocalStorageService';
// import { useEnquiryEmailSubmission } from 'all-in-one-shared-api';
// import { PrimaryButton } from 'components';
import styled from 'styled-components';

// import { useKeycloakReady } from 'hooks/useKeycloakReady';
const ResponsiveDiv = styled.div`
  background: white;
  padding-top: 40px;
  margin-left: 160px;
  margin-right: 160px;

  @media (max-width: 768px) {
    padding: 0px;
    margin: 0px;
  }
`;
const ResponsiveDiv2 = styled.div`
  padding-left: 160px;
  padding-right: 160px;
  padding-top: 24px;
  padding-bottom: 24px;
  @media (max-width: 768px) {
    padding: 0px;
    margin: 0px;
  }
`;

export const CreditCardSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lastPayment } = useLastPayment();
  useEffect(() => {
    return () => {
      localStorageService.remove('LastPayment');
    };
  }, []);
  // if (!lastPayment?.referenceNo) {
  //   return <Navigate to="/notFound" replace={true} />;
  // }

  return (
    <>
      <ResponsiveDiv2>
        {/* <Typography.Text
          style={{
            fontFamily: 'Roboto400',
            fontSize: '33px',
            color: 'black',
            // background: 'red',
            display: 'block',
            textAlign: 'left',
          }}
        >
          {'Document Uploaded'}
        </Typography.Text> */}
      </ResponsiveDiv2>
      <ResponsiveDiv style={{ background: 'white' }}>
        <Typography.Text
          style={{
            fontFamily: 'Roboto400',
            fontSize: '26px',
            color: '#6f7072',
            // background: 'red',
            display: 'block',
            textAlign: 'center',
            whiteSpace: 'pre-line',
          }}
        >
          {t('life.Payment.successlabel')}
        </Typography.Text>
        <Result
          icon={<img style={{ width: '153px', height: '153px' }} src={imageSource} />}
          extra={
            <Space direction="vertical">
              <div style={{ maxWidth: '640px' }}>
                <Typography.Text
                  style={{ fontFamily: 'Roboto400', fontSize: '26px', color: '#6f7072', whiteSpace: 'pre-line' }}
                >
                  {t('life.Payment.successlabel2', { referenceNo: lastPayment?.referenceNo })}
                </Typography.Text>
              </div>
              {lastPayment?.inactiveAutoPayAccount == 'Y' && (
                <div style={{ maxWidth: '640px' }}>
                  <Typography.Text
                    style={{ fontFamily: 'Roboto400', fontSize: '18px', color: '#c21b17', whiteSpace: 'pre-line' }}
                  >
                    {t('life.Payment.successlabel3')}
                  </Typography.Text>
                </div>
              )}
              <Button
                block
                className="btn"
                type="primary"
                size="large"
                style={{
                  marginTop: '12px',
                  // maxWidth: '100%',
                  width: '80%',
                  height: '56px',
                  fontSize: '20px',
                  fontFamily: 'Roboto500',
                }}
                onClick={() =>
                  lastPayment?.inactiveAutoPayAccount == 'Y'
                    ? navigate('/ChangePaymentArrangement', { state: { policyNo: lastPayment?.policyNumber } })
                    : navigate('/LIPayment', { state: { tabs: 1 } })
                }
              >
                {lastPayment?.inactiveAutoPayAccount == 'Y' ? t('life.home.setupnow') : t('common.done')}
              </Button>
            </Space>
          }
        />
      </ResponsiveDiv>
    </>
  );
};
